"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoLaunch = void 0;

require("url-search-params-polyfill");

var _env = require("../env");

var _approuters = require("../common/approuters");

var _websdk = require("../websdk");

/**
 * @file 根据 URL 参数自动打开指定页面，以及上传给客户端日志
 * @author qiaogang
 * @date 2020-02-13
 */

/**
 * 根据 autolaunch 所指定的路径，自动打开对应的页面
 */
var autoLaunch = {
  // _options: {},
  //
  // config(options) {
  //   this._options = options;
  //   return this;
  // },
  init: function init() {
    // 自动唤起 App 逻辑，非 App、非微信环境下，唤起 App
    var urlSearch = new URLSearchParams(location.search);
    var autoLaunch = urlSearch.get('autolaunch'); // 会把 igc_from 字段透传给 App 的 from_source，用于 App 统计

    var igcFrom = urlSearch.get('igc_from') || 'igetcool'; // 如果没安装，是否自动调换下载，默认关上
    // const autoDownload = urlSearch.get('autodl');
    // 自动跳，只在普通浏览器中有效，微信内暂时不自动跳

    if (autoLaunch && !_env.env.isApp) {
      var url = _approuters.appRouter.home; // 特别说明 这里暂时把decodeURIComponent去掉 此处decode后会导致 安卓仅能获取一个query参数 后面被截掉
      // APP想要的格式是以下格式 即：params_url=的值应该不被decode 客户端会自行decode
      // igetcool://juvenile.dedao.app/go/h5?params_url=https%3A%2F%2Fqa-share-test.igetcool.com%2Fmall%2Fcourse%3Fitemid%3D1470658384796631041%26igc_from%3Dxxx&start_url_source=demo&start_url=http%3A%2F%2F172.30.105.101%3A8080%2F%3Fautolaunch%3Digetcool%253A%252F%252Fjuvenile.dedao.app%252Fgo%252Fh5%253Fparams_url%253Dhttps%25253A%25252F%25252Fqa-share-test.igetcool.com%25252Fmall%25252Fcourse%25253Fitemid%25253D1470658384796631041%252526igc_from%25253Dxxx%26igc_from%3Ddemo

      var decodeUrl = autoLaunch; // decodeURIComponent(autoLaunch);

      if (decodeUrl.indexOf('igetcool://') === 0) {
        url = decodeUrl;
      }

      if (url.indexOf('?') !== -1) {
        url += "&";
      } else {
        url += '?';
      } // 日志
      // start_url_source 是跳转来源渠道标识
      // start_url 是发起跳转的页面（来源页面）


      url += "start_url_source=".concat(igcFrom, "&start_url=").concat(encodeURIComponent(location.href));
      setTimeout(function () {
        _websdk.webSDK.openApp(url, {
          preventDownload: true
        });
      }, 200);
    }
  }
};
exports.autoLaunch = autoLaunch;